// extracted by mini-css-extract-plugin
export default {"content":"ViewPDF_content__zPHSB","minimalView":"ViewPDF_minimalView__2NZEx","marginPages":"ViewPDF_marginPages__pozqw"};